import Layout from "@/views/Layout.vue";

const router = [
  {
    path: "/contact-us", //联系我们
    name: "contact-us",
    component: () => import("@/views/contact-us/Index.vue"),
  },
];
const routerItem = {
  path: "/",
  redirect: "/contact-us",
  component: Layout,
  children: router,
};

export default routerItem;
